export const GET_SAVED_SEARCH_DEFAULT_PAGE_SIZE = 250;